// This file configures the initialization of Sentry on the client.
// The added config here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/about\"},{\"path\":\"/api/auth/verify\"},{\"path\":\"/profile\"},{\"path\":\"/profile/badges\"},{\"path\":\"/profile/history\"},{\"path\":\"/profile/settings\"},{\"path\":\"/profile/stats\"},{\"path\":\"/signin\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.0";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';

Sentry.init({
  dsn: 'https://01e2c1b2ff6ed73a64f092f5903a190f@o4509521918623744.ingest.us.sentry.io/4511820048695296',

  // Define how likely traces are sampled. Adjust this value in production, or use tracesSampler for greater control.
  tracesSampleRate: 1,
  // Enable logs to be sent to Sentry
  enableLogs: true,

  dataCollection: {
    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/#dataCollection
    // userInfo: false,
    // httpBodies: [],
  },
  ...(process.env.NODE_ENV === 'production'
    ? {}
    : {
      spotlight: true, // Enable Spotlight
      sampleRate: 1, // Capture all errors in dev
      tracesSampleRate: 1, // Capture all traces in dev
      enableLogs: true,
      integrations: [
        Sentry.consoleLoggingIntegration({
          levels: ['log', 'warn', 'error'],
        }),
        // For frontend apps, add:
        Sentry.browserTracingIntegration(),
      ],
    }),
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
